export default {"src":"__ASTRO_ASSET_IMAGE__CFfiM18R__","width":492,"height":328,"format":"png"}